<template>
  <div>
    <div class="applicationList div-layout">
      <div
        v-show="!hiddenVariable.dialogEditVisible && !hiddenVariable.dialogVersionVisible"
        class="applicationList-main"
      >
        <module-title title="应用管理">
          <div class="right">
            <el-button type="primary" size="medium" icon="el-icon-plus" @click="opAddOrEdit">
              添加应用
            </el-button>
          </div>
        </module-title>
        <div class="applicationList-main-contain">
          <el-form
            ref="searchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
            @submit.native.prevent
          >
            <el-form-item label="状态：" prop="status">
              <el-select
                v-model="searchForm.status"
                name="status"
                size="medium"
                class="handle-form-input"
              >
                <el-option label="全部" value="" />
                <el-option label="启用" :value="1" />
                <el-option label="禁用" :value="-1" />
              </el-select>
            </el-form-item>
            <el-form-item label="适用年级：" prop="status">
              <el-select
                v-model="searchForm.stage"
                name="status"
                size="medium"
                class="handle-form-input"
                @change="selectStage"
              >
                <el-option
                  v-for="item in stageArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="适用学科：" prop="subject">
              <el-select
                v-model="searchForm.subject"
                name="terminalCode"
                size="medium"
                class="handle-form-input"
              >
                <el-option
                  v-for="item in subjectArr"
                  :key="item.subjectName"
                  :label="item.subjectName"
                  :value="item.subjectId"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="应用类型：" prop="whetherWithNew">
              <el-select
                v-model="searchForm.whetherWithNew"
                name="terminalCode"
                size="medium"
                class="handle-form-input"
              >
                <el-option
                  v-for="item in whetherWithNewArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <div class="query">
              <el-input
                v-model="searchForm.name"
                name="name"
                maxlength="10"
                placeholder="请输入应用名称"
                style="width:300px"
                @keyup.enter.native="handleSearchFilter"
              />
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </div>
          </el-form>
          <multiple-box :visible="isSelection" :selection-num="selectionNum">
            <span class="handle-span" @click="multipleEditStatus(1)">批量上架</span>
            <span class="handle-span" @click="multipleEditStatus(-1)">批量下架</span>
          </multiple-box>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="应用名称" prop="appName" align="center" />
            <el-table-column label="版本号" prop="applicationEditionVO.editionNo" align="center" width="80" />
            <el-table-column label="应用大小" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.applicationEditionVO"> {{ scope.row.applicationEditionVO.fileSize | toFixedCustom }}MB</span>
              </template>
            </el-table-column>
            <el-table-column label="适用年级" prop="updateDate" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.gradeList" :key="index">
                  {{ item.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="适用学科" prop="updateDate" align="center" width="138" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.subjectList" :key="index">
                  {{ item.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.status === '1' ? '已上架' : '已下架' }}
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              prop="createDate"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column label="操作" align="center" width="300px">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="small"
                  icon="el-icon-info"
                  @click="viewApplicationDetail(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-link"
                  @click="gotoVersion(scope.row)"
                >
                  版本
                </el-button>
                <!-- <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                @click="deleteAddApplication(scope.row)"
              >删除</el-button> -->
                <el-dropdown
                  trigger="click"
                  class="moreBtn"
                  @visible-change="scope.row.more = !scope.row.more"
                  @command="handleCommand($event, scope.row)"
                >
                  <el-button type="primary" size="small">
                    更多
                    <i
                      :class="[
                        scope.row.more ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
                        'el-icon--right'
                      ]"
                    />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="blue" command="a" icon="el-icon-edit">
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-show="scope.row.status != '1'"
                      class="blue"
                      command="c"
                      icon="el-icon-success"
                    >
                      上架
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-show="scope.row.status == '1'"
                      class="blue"
                      command="c"
                      icon="el-icon-warning-outline"
                    >
                      下架
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <add-application
        v-if="hiddenVariable.dialogEditVisible"
        :visible.sync="hiddenVariable.dialogEditVisible"
        :handle-type="handleType"
        :terminal-list="terminalList"
        :application-detail="applicationDetail"
        :apptypes-tree="apptypesTree"
        @onSuccess="fetchApplicationList"
      />
      <version-manage
        v-if="hiddenVariable.dialogVersionVisible"
        :visible.sync="hiddenVariable.dialogVersionVisible"
        :app-id="handleAppId"
        :app-name="appName"
        :terminal-id="terminalId"
        :apply-terminals="applyTerminals"
        @onSuccess="fetchApplicationList"
      />
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogDetailVisible"
        title="应用详情"
        width="650px"
        @close="closeVideo"
      >
        <div class="manager-info">
          <ul>
            <li>
              <label for>应用名称：</label>
              {{ applicationDetail.appName }}
            </li>
            <li>
              <label for>应用类型：</label>
              {{ applicationDetail.appTypeName }}
            </li>
            <li>
              <label for>应用标签：</label>
              <span v-if="applicationDetail.terminalId === 1">联机应用</span>
              <span v-if="applicationDetail.terminalId === 2">教师应用</span>
              <span v-if="applicationDetail.terminalId === 3">学生应用</span>
            </li>
            <li>
              <label for>logo：</label>
              <img :src="applicationDetail.appIconUrl" alt class="logo-detail">
            </li>
            <li>
              <label for>学段：</label>
              <span v-for="(item, index) in applicationDetail.gradeList" :key="index">
                {{ item.name }}
              </span>
            </li>
            <li>
              <label for>科目：</label>
              <span v-for="(item, index) in applicationDetail.subjectList" :key="index">
                {{ item.name }}
              </span>
            </li>
            <li>
              <label for>前端下载虚拟系数：</label>
              {{ applicationDetail.downloads }}
            </li>
            <li>
              <label for>当前版本：</label>
              <span v-if="applicationDetail.applicationEditionVO">
                {{ applicationDetail.applicationEditionVO.editionNo }}
              </span>
            </li>
            <li>
              <label for>应用简介：</label>
              <span>{{ applicationDetail.introduction }}</span>
            </li>

            <li>
              <label for>应用视频：</label>
              <span>
                <video v-if="applicationDetail.videoUrl" ref="vueRef" class="ql-video" controls="controls" autoplay="true" type="video/mp4" :src="applicationDetail.videoUrl" width="100%" />
              </span>
            </li>
            <li>
              <label for>应用视频封面：</label>
              <span><img v-if="applicationDetail.videoCoverUrl" :src="applicationDetail.videoCoverUrl" width="100" height="100"></span>
            </li>
            <li>
              <label for>应用图片：</label>
              <span v-if="applicationDetail.pictureUrls&&applicationDetail.pictureUrls.length>0">
                <span v-for="(v,i) in applicationDetail.pictureUrls" :key="v+i" class="pictureUrls">
                  <img
                    :src="v"
                    class="avatar"
                    width="100"
                    height="100"
                  >
                </span></span>
            </li>
            <li>
              <label for>官网首页推荐图片：</label>
              <img :src="applicationDetail.homePagePictureUrl" alt class="homePic-detail">
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import AddApplication from './addApplication';
import VersionManage from './versionManage';
import { formatTimeToStr } from '@/utils/index';
import {
  getDictsType
} from '@/api/productOperation/common/applicationManage';
import {
  appList,
  getAppTypeSelect,
  getSubjects,
  getGrades,
  queryDetail,
  versionStatusBatch
} from '@/api/productOperation/wisdom/applicationList';
import { getApptypesTree } from '@/api/productOperation/common/applicationTypeManage';
import { mapGetters } from 'vuex';
export default {
  name: 'WisdomApplicationList',
  components: {
    AddApplication,
    VersionManage
  },
  filters: {
    toFixedCustom(value) {
      const res = (value / 1024) / 1024;
      const realVal = parseFloat(res).toFixed(2);
      return realVal;
    }
  },
  data() {
    return {
      // 弹框标题
      appName: '', // 应用名称
      handleType: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        // 详情
        dialogDetailVisible: false, // 详情标识
        // 版本管理
        dialogVersionVisible: false
      },
      stageArr: [],
      // 搜索表单
      searchForm: {
        terminalCode: '',
        status: '',
        name: '',
        stage: '',
        subject: '',
        pageNum: 1,
        total: 0,
        pageSize: 10,
        whetherWithNew: '', // 应用类型
        typeCode: 'C15'
      },
      handleAppId: '',
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选,
      applicationList: [],
      terminalList: [], //  终端列表
      applicationDetail: {},
      apptypesTree: [],
      whetherWithNewArr: [],
      subjectArr: [],
      terminalId: '',
      applyTerminals: [],
      option: {}
    };
  },
  computed: {
    ...mapGetters(['currentProdeuctId']),
    formatTimeToStr() {
      return formatTimeToStr;
    },
    // 是否多选
    isSelection() {
      return this.multipleSelection.length > 0;
    },
    // 多选数量
    selectionNum() {
      return this.multipleSelection.length;
    },
    // 是否是上架的
    hasUsing() {
      return this.multipleSelection.findIndex((item) => item.status) > -1;
    },
    // 是否是下架的
    hasUnUsing() {
      return this.multipleSelection.findIndex((item) => !item.status) > -1;
    }
  },
  mounted() {
    this.fetchApplicationList();
    this.initForm();
    this.fetchTerminalList();
    this.fetchApptypesTree();
  },
  methods: {
    closeVideo() {
      if (this.$refs.vueRef) {
        this.$refs.vueRef.pause();// 暂停
      }
    },
    initForm() {
      getAppTypeSelect({ typeCode: 'C15' }).then(res => {
        this.whetherWithNewArr = [
          { name: '全部', id: '' },
          ...res.data
        ];
      });
      getGrades({ typeCode: 'C15' }).then(res => {
        this.stageArr = [
          { name: '全部', id: '' },
          ...res.data
        ];
      });
    },
    selectStage(row) {
      console.log(row);
      if (row.length < 1) {
        this.searchForm.subject = '';
        this.subjectArr = [];
        return;
      }
      const data = {
        gradeIds: row,
        typeCode: 'C15'
      };
      getSubjects(data).then(res => {
        this.subjectArr = [
          { subjectName: '全部', stageId: '', subjectId: '' },
          ...res.data
        ];
        this.searchForm.subject = '';
        console.log(this.subjectArr);
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.option = {
        terminalCode: this.searchForm.terminalCode,
        status: this.searchForm.status,
        name: this.searchForm.name,
        stage: this.searchForm.stage,
        subject: this.searchForm.subject,
        whetherWithNew: this.searchForm.whetherWithNew, // 应用类型
        typeCode: this.searchForm.terminalCode
      };
      this.fetchApplicationList();
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 打开新增编辑弹框
    opAddOrEdit() {
      this.handleType = 'add';
      this.hiddenVariable.dialogEditVisible = true;
    },
    gotoVersion(row) {
      this.appName = row.appName;
      this.handleAppId = row.id;
      this.terminalId = row.terminalId;
      this.applyTerminals = row.applyTerminals;
      this.hiddenVariable.dialogVersionVisible = true;
    },
    // 查看详情
    viewApplicationDetail(row) {
      const data = {
        manageIdList: row.id,
        typeCode: 'C15'
      };
      queryDetail(data)
        .then((result) => {
          this.applicationDetail = result.data[0];
          // 应用类型名称
          this.applicationDetail.appTypesName =
            this.applicationDetail.appTypes && this.applicationDetail.appTypes.length
              ? this.applicationDetail.appTypes.map((x) => x.name).join('，')
              : '';
          // 终端名称
          this.applicationDetail.appTerminalsName =
            this.applicationDetail.appTerminals && this.applicationDetail.appTerminals.length
              ? this.applicationDetail.appTerminals.map((x) => x.name).join('，')
              : '';
          this.hiddenVariable.dialogDetailVisible = true;
          if (this.$refs.vueRef) {
            this.$refs.vueRef.play();// 暂停
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 更多下拉菜单点击事件
    handleCommand(command, row) {
      if (command === 'a') {
        // 编辑成员
        const data = {
          manageIdList: row.id,
          typeCode: 'C15'
        };
        queryDetail(data)
          .then((result) => {
            this.applicationDetail = result.data[0];
            console.log(this.applicationDetail);
            this.handleType = 'edit';
            this.hiddenVariable.dialogEditVisible = true;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (command === 'c') {
        this.$confirm(`确定要${row.status === '1' ? '下架' : '上架'}该应用么?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            var id = row.status;
            console.log(id);
            const form = {
              ids: [row.id.toString()],
              status: id === '0' ? '1' : '0',
              typeCode: 'C15'
            };
            return versionStatusBatch(form);
          })
          .then((res) => {
            this.$notify.success({
              title: 'Success',
              message: `${row.status === '1' ? '下架' : '上架'}成功`,
              showClose: false,
              duration: 2000
            });
            this.fetchApplicationList();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    // 批量上架或者下架
    multipleEditStatus(type) {
      let str = '';
      let status = 1;
      let ids = [];
      let num = 0;
      // 上架
      if (type === 1) {
        str = '上架';
        status = '1';
        // 筛选出是下架状态的数据
        const idArr = this.multipleSelection.filter((item) => {
          if (item.status != '1') {
            return item.status;
          }
        });
        console.log(idArr);
        // 如果全部为上架状态则给出提示
        if (idArr.length === 0) {
          this.$message.warning('应用全部为已上架状态');
          return false;
        } else {
          // 数组转字符串
          ids = idArr.map((item) => item.id);
          num = idArr.length;
        }
        // 下架
      } else {
        str = '下架';
        status = '0';
        // 筛选出是上架状态的数据
        const idArr = this.multipleSelection.filter((item) => {
          if (item.status === '1') {
            return item.status;
          }
        });
        // 如果全部为下架状态则给出提示
        if (idArr.length === 0) {
          this.$message.warning('应用全部为已下架状态');
          return false;
        } else {
          // 数组转字符串
          ids = idArr.map((item) => item.id);
          num = idArr.length;
        }
      }
      this.$confirm(`当前已选择${num}个应用，确定要批量${str}么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            ids: ids,
            status: status,
            typeCode: 'C15'
          };
          return versionStatusBatch(form);
        })
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: `${str}成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      this.searchForm.selectType = 1;
      var gradeType = '';
      if (this.searchForm.stage) {
        console.log('需要');
        gradeType = 1;
      }
      const data = {
        status: this.option.status,
        gradeCode: this.option.stage,
        subjectCode: this.option.subject,
        referenceId: this.option.whetherWithNew,
        appName: this.option.name,
        selectType: 1,
        gradeType,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        typeCode: 'C15'
      };
      appList(data)
        .then((result) => {
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },

    // 获取终端字典
    fetchTerminalList() {
      getDictsType('terminal_type')
        .then((result) => {
          this.terminalList = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取应用类型列表
    fetchApptypesTree() {
      getApptypesTree(this.searchForm)
        .then((result) => {
          this.apptypesTree = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.applicationList {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 150px;
}
.moreBtn {
  margin-left: 10px;
}
.newtip {
  font-style: normal;
  color: #fff;
  background: red;
  margin-left: 5px;
}
.manager-info {
  display: flex;
  ul {
    margin-left: 60px;
    width: 100%;
    min-width: 220px;
    li {
      label {
        margin-right: 10px;
      }
      margin-bottom: 20px;
      .intro-picture {
        display: inline-block;
        img {
          vertical-align: text-top;
          width: 100px;
          height: 100px;
          margin-right: 10px;
        }
      }
      .logo-detail {
        vertical-align: text-top;
        width: 100px;
        height: 100px;
      }
      .homePic-detail{
        vertical-align: text-top;
        width: 350px;
        height: 150px;
      }
    }
  }
}
.query {
  // display: flex;
  // justify-content: center;
  // margin-left: -10px;
  display: inline-block;
}
/deep/.query button {
  margin-left: 20px;
}
</style>
